module.exports = "https://r.nearpod.com/assets/media/image/teacher_resources_icon-7497fb4745d0e57643975b140be873c3.svg";